import Vue from 'vue/dist/vue.esm'
import template from './applied_filters_row_template.slim'

const MAX_VISIBLE = 6
const MIN_VISIBLE = 3
const DEFAULT_GAP = 8
const PANEL_EDGE_GAP = 8

Vue.component('applied-filters-row', {
  mixins: [template],
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false,
      visibleCount: MAX_VISIBLE
    }
  },
  computed: {
    visible() {
      return this.filters.slice(0, this.visibleCount)
    },
    hidden() {
      return this.filters.slice(this.visibleCount)
    },
    overflowLabel() {
      return `+${this.hidden.length}`
    },
    showClearAll() {
      return this.filters.length > 1
    }
  },
  watch: {
    filters() {
      this.$nextTick(() => this.measure(true))
    },
    hidden(newValue) {
      if (!newValue.length) this.isOpen = false
    },
    isOpen(open) {
      if (!open) this.panelLeft = null
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
    this.measure()
    if (typeof ResizeObserver === 'undefined') return

    this.resizeObserver = new ResizeObserver(this.scheduleMeasure)
    this.resizeObserver.observe(this.$el)
    const card = this.$el.closest('.chart-filterable')
    if (card) this.resizeObserver.observe(card)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
    this.resizeObserver?.disconnect()
    if (this.measureFrame) window.cancelAnimationFrame(this.measureFrame)
  },
  methods: {
    availableWidth() {
      const style = window.getComputedStyle(this.$el)
      return this.$el.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)
    },
    fittingCount(widths, available, gap, reserved) {
      const budget = available - reserved
      let used = 0
      let count = 0

      for (const width of widths) {
        const next = used + (count ? gap : 0) + width
        if (next > budget) break

        used = next
        count += 1
      }
      return count
    },
    scheduleMeasure() {
      if (this.measureFrame) return

      this.measureFrame = window.requestAnimationFrame(() => {
        this.measureFrame = null
        this.measure()
      })
    },
    measure(force = false) {
      const chips = this.$refs.chip
      if (!chips || !chips.length) return

      const available = this.availableWidth()
      if (force || available !== this.lastAvailable) {
        this.lastAvailable = available
        const gap = parseFloat(window.getComputedStyle(this.$el).columnGap) || DEFAULT_GAP
        const widths = chips.map((chip) => chip.offsetWidth)
        const clearWidth = this.showClearAll ? this.$refs.measureClear.offsetWidth + gap : 0
        const overflowWidth = this.$refs.measureOverflow.offsetWidth + gap

        let count = Math.min(this.fittingCount(widths, available, gap, clearWidth), MAX_VISIBLE)
        if (count < widths.length) {
          count = Math.min(this.fittingCount(widths, available, gap, clearWidth + overflowWidth), MAX_VISIBLE)
        }
        this.visibleCount = Math.max(count, MIN_VISIBLE)
      }
      if (this.isOpen) this.reclampPanel()
    },
    toggle() {
      this.isOpen = !this.isOpen
      if (this.isOpen) this.$nextTick(this.alignPanel)
    },
    alignPanel() {
      this.positionPanel(true)
    },
    reclampPanel() {
      this.positionPanel(false)
    },
    positionPanel(anchorToOverflow) {
      const panel = this.$refs.panel
      const overflow = this.$refs.overflow
      if (!panel || !overflow) return

      panel.style.left = ''
      if (window.getComputedStyle(overflow).position === 'static') {
        this.panelLeft = null
        return
      }

      const card = this.$el.closest('.chart-filterable') || this.$el
      const cardRect = card.getBoundingClientRect()
      const anchor = overflow.getBoundingClientRect().left
      const maxLeft = cardRect.right - PANEL_EDGE_GAP - panel.offsetWidth
      const minLeft = cardRect.left + PANEL_EDGE_GAP
      const preferred = anchorToOverflow || this.panelLeft === null ? anchor : this.panelLeft

      this.panelLeft = Math.max(minLeft, Math.min(preferred, maxLeft))
      panel.style.left = `${this.panelLeft - anchor}px`
    },
    removeLabel(filter) {
      return `Remove ${filter.label} filter`
    },
    remove(filter) {
      this.$emit('remove', filter)
    },
    clear() {
      this.$emit('clear')
    },
    handleOutsideClick(event) {
      if (!this.isOpen) return
      if (event.composedPath().includes(this.$el)) return

      this.isOpen = false
    }
  }
})
